<template>
  <div class="slider">
    <div :class="{ page: true, sidebar: true, 'sidebar-animation': pageZeroIsOpen }">
      <div id="sidebar-shadow" class="page-shadow"></div>
      <div id="sidebar-background" class="page-background"></div>
      <div class="sidebar-container">
        <img id="bubble" src="@/assets/practices/saving_money/sidebar_bubble.svg" alt="bubble" />
        <h1 class="title">Saving Money</h1>
        <div id="pig-slider"></div>
      </div>
      <div :class="{ 'page-container': true, 'page-container-animation': pageZeroIsOpen }">
        <slot name="zero-page"></slot>
      </div>
    </div>
    <div id="first-page" class="page">
      <div id="first-page-shadow" class="page-shadow"></div>
      <div id="first-page-background" class="page-background"></div>
      <div class="page-container">
        <slot name="first-page"></slot>
      </div>
    </div>
    <div id="second-page" class="page">
      <div id="second-page-shadow" class="page-shadow"></div>
      <div id="second-page-background" class="page-background"></div>
      <div class="page-container">
        <slot name="second-page"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import lottie from 'lottie-web/build/player/lottie';

export default {
  name: 'Slider',
  props: {
    pageZeroIsOpen: Boolean,
    pageOneIsOpen: Boolean,
    pageTwoIsOpen: Boolean,
  },
  watch: {
    pageOneIsOpen: function (state) {
      if (state) {
        this.openPage('first-page', 'second-page');
      } else {
        this.closePage('first-page');
      }
    },
    pageTwoIsOpen: function (state) {
      if (state) {
        this.openPage('second-page');
      } else {
        if (this.pageOneIsOpen) {
          this.closePage('first-page', 'second-page');
        } else {
          this.closePage('second-page');
        }
      }
    },
  },
  mounted() {
    lottie.loadAnimation({
      container: document.getElementById('pig-slider'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/practices/saving_money/animations/pig.json',
    });
    this.loadPage();
  },
  methods: {
    openPage(pageOne, pageTwo) {
      document.getElementById(pageOne).classList.remove('page-close');
      document.getElementById(pageOne).classList.add('page-open');
      if (pageTwo) {
        document.getElementById(pageTwo).classList.remove('page-close');
        document.getElementById(pageTwo).classList.add('page-open');
      }
    },
    closePage(pageOne, pageTwo) {
      document.getElementById(pageOne).classList.remove('page-open');
      document.getElementById(pageOne).classList.add('page-close');
      if (pageTwo) {
        document.getElementById(pageTwo).classList.remove('page-open');
        document.getElementById(pageTwo).classList.add('page-close');
      }
    },
    loadPage() {
      if (this.pageOneIsOpen) {
        this.openPage('first-page', 'second-page');
      }
      if (this.pageTwoIsOpen) {
        this.openPage('second-page');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.slider {
  @include flex-center;
  height: 100vh;
  position: absolute;
  width: 100vw;
  z-index: 1;

  .page {
    @include flex-center;
    flex-direction: column;
    height: 100vh;
    position: absolute;
    width: 70vw;

    .page-container {
      @include flex-center;
      height: 100%;
      position: absolute;
      right: 0;
      width: 81%;
      z-index: 2;
    }
  }

  .page-background,
  .page-shadow {
    height: 100%;
    position: absolute;
    width: 100%;

    &:before {
      border-style: solid;
      border-width: 100vh 7.5vh 0px 0px;
      content: '';
      position: absolute;
      right: -7.6vh;
      top: 0px;
      transform: translate(-1px, 0);
    }
  }

  .page-shadow {
    left: 1vh;
  }

  #first-page {
    left: -51vw;
    z-index: 2;
  }

  #second-page {
    left: -49.25vw;
    z-index: 1;
  }

  .sidebar {
    @include flex-center;
    color: $saving-money-color-text-title;
    flex-direction: column;
    height: 100vh;
    left: 0;
    position: absolute;
    text-align: center;
    width: 17vw;
    z-index: 3;

    .sidebar-container {
      @include flex-center;
      flex-direction: column;
      height: 100vh;
      left: 0;
      position: absolute;
      width: 20vw;

      .title {
        transform: rotateZ(-90deg);
        width: 50vh;
        z-index: 2;
      }

      #bubble {
        bottom: -2.5vh;
        right: 1vh;
        position: absolute;
        width: 50vh;
      }

      #pig-slider {
        height: 30vh;
        width: 30vh;
        z-index: 2;
      }
    }
  }

  .sidebar-animation {
    animation: sidebar-width 2s forwards;
  }

  .page-container-animation {
    animation: fade-in 2s forwards;
    animation-delay: 1s;
    opacity: 0;
  }
}

// Individual Page CSS
@mixin page-properties($backgroundId, $backgroundColor, $shadowId, $shadowColor) {
  ##{$backgroundId} {
    background-color: #{$backgroundColor};

    &:before {
      border-color: #{$backgroundColor} transparent #{$backgroundColor} transparent;
    }
  }

  ##{$shadowId} {
    background-color: #{$shadowColor};

    &:before {
      border-color: #{$shadowColor} transparent #{$shadowColor} transparent;
    }
  }
}

@include page-properties(sidebar-background, #48b7d4, sidebar-shadow, #40a0b8);
@include page-properties(first-page-background, #48d4c0, first-page-shadow, #41c0ad);
@include page-properties(second-page-background, #61c69b, second-page-shadow, #58b38b);

// Animation CSS
.page-open {
  animation: page-open 2s forwards;
}

.page-close {
  animation: page-close 2s forwards;
}

@keyframes page-close {
  0% {
    transform: translate(60vw, 0);
  }
  100% {
    transform: translate(0vw, 0);
  }
}

@keyframes page-open {
  0% {
    transform: translate(0vw, 0);
  }
  100% {
    transform: translate(60vw, 0);
  }
}

@keyframes sidebar-width {
  0% {
    width: 20vw;
  }
  100% {
    width: 85vw;
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

// Media Queries
@media (max-aspect-ratio: 8/5) {
  .slider {
    .sidebar {
      width: 26vw;

      .sidebar-container {
        left: 5vh;
      }
    }

    .page {
      .page-container {
        width: 70%;
      }
    }
    #first-page {
      left: -41vw;
      z-index: 2;
    }

    #second-page {
      left: -38.5vw;
      z-index: 1;
    }
  }

  @keyframes page-close {
    0% {
      transform: translate(52.5vw, 0);
    }
    100% {
      transform: translate(0vw, 0);
    }
  }
  @keyframes page-open {
    0% {
      transform: translate(0vw, 0);
    }
    100% {
      transform: translate(52.5vw, 0);
    }
  }
}
</style>
